/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StoragePolicyFilter } from './storagePolicyFilter';
import { StoragePolicyRule } from './storagePolicyRule';
import { StoragePolicyTransition } from './storagePolicyTransition';


export interface StoragePolicyUpdateRequest { 
    storagePolicyRule: StoragePolicyRule;
    storagePolicyFilter: StoragePolicyFilter;
    storagePolicyTransition: StoragePolicyTransition;
    /**
     * The status of the storage policy. Supported values are: ENABLED, DISABLED
     */
    status: string;
}
